// extracted by mini-css-extract-plugin
module.exports = {"infoMessage":"InfoMessage_infoMessage__6c1H5"};